import { FC } from 'react';
import ContentLoader from 'react-content-loader';

import { useCommonStore } from '@/store';

import {
  ScSkeletonProps,
  ScStaticModalSkeleton,
  ScStaticModalSkeletonMobile,
} from './styled';

interface SkeletonProps extends ScSkeletonProps {}

export const Skeleton: FC<SkeletonProps> = (props) => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return !isMobileDevice ? (
    <StaticModalSkeleton {...props} />
  ) : (
    <StaticModalSkeletonMobile />
  );
};

export const StaticModalSkeleton: FC<SkeletonProps> = (props) => (
  <ScStaticModalSkeleton {...props}>
    <ContentLoader
      viewBox={
        props.width ? `0 0 ${props.width} ${props.width + 120}` : '0 0 480 500'
      }
      speed={2}
      foregroundColor="#ecebeb"
      backgroundColor="#ccc"
    >
      <rect x="0" y="15" rx="5" ry="5" width="60%" height="30" />
      <rect x="0" y="80" rx="4" ry="4" width="190" height="50" />
      <rect x="15" y="210" rx="4" ry="4" width="80%" height="15" />
      <rect x="15" y="250" rx="4" ry="4" width="70%" height="15" />
    </ContentLoader>
  </ScStaticModalSkeleton>
);

export const StaticModalSkeletonMobile = () => (
  <ScStaticModalSkeletonMobile>
    <ContentLoader
      width="100%"
      height="100%"
      speed={2}
      foregroundColor="#ecebeb"
    >
      <rect x="15" y="15" rx="5" ry="5" width="60%" height="30" />
      <rect x="15" y="80" rx="4" ry="4" width="190" height="50" />
      <rect x="15" y="210" rx="4" ry="4" width="80%" height="15" />
      <rect x="15" y="250" rx="4" ry="4" width="70%" height="15" />
    </ContentLoader>
  </ScStaticModalSkeletonMobile>
);
